import { memo, useRef, useCallback, useState, useEffect } from 'react'
import classNames from 'classnames'
import injectSheet from 'react-jss'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import style from './style'

const CarouselProductMobile = ({
  classes,
  className,
  items,
}) => {
  const autoplay = useRef(
    Autoplay(
      { delay: 2000, stopOnInteraction: false },
      (emblaRoot) => emblaRoot.parentElement,
    ),
  )
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    skipSnaps: false,
  }, [autoplay.current])
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [scrollSnaps, setScrollSnaps] = useState([])

  const scrollTo = useCallback((index) => {
    if (!emblaApi) return
    emblaApi.scrollTo(index)
    autoplay.current.reset()
  }, [emblaApi])

  /*------------------------------
  Handle Select
  ------------------------------*/
  const onSelect = useCallback(() => {
    if (!emblaApi) return
    setSelectedIndex(emblaApi.selectedScrollSnap())
  }, [emblaApi, setSelectedIndex])

  /*------------------------------
  Manage events
  ------------------------------*/
  useEffect(() => {
    if (!emblaApi) return
    onSelect()
    setScrollSnaps(emblaApi.scrollSnapList())
    emblaApi.on('select', onSelect)
  }, [emblaApi, setScrollSnaps, onSelect])

  /*------------------------------
  Init Create Slider
  ------------------------------*/
  useEffect(() => {
    if (!emblaApi) return
    emblaApi.reInit()
  }, [items, emblaApi])

  return items.length > 0 && (
    <div
      className={classNames({
        [classes.root]: true,
        [className]: className,
      })}
    >
      <div
        ref={emblaRef}
        className={classes.slider}
      >
        <div className={classes.slides}>
          {items.map((item, index) => (
            <div
              key={index.toString()}
              tabIndex={index.toString()}
              className={classNames({
                [classes.carouselItem]: true,
                Carousel__carouselItem: true,
                Carousel__carouselItemVertical: item.image.height > item.image.width,
              })}
            >
              <div
                className={classNames({
                  [classes.carouselSlide]: true,
                  Carousel__carouselSlide: true,
                })}
              >
                <div
                  className={classNames({
                    [classes.carouselImg]: true,
                    Carousel__carouselImg: true,
                  })}
                >
                  <img
                    src={item.image.url}
                    alt={item.image.caption}
                  />
                </div>
                <div
                  className={classNames({
                    [classes.carouselText]: true,
                    Carousel__carouselText: true,
                  })}
                >
                  <h3 dangerouslySetInnerHTML={{ __html: item.title }} />
                  <div dangerouslySetInnerHTML={{ __html: item.text }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={classes.dots}>
        {scrollSnaps.map((_, index) => (
          <button
            key={index.toString()}
            className={classNames({
              [classes.dot]: true,
              [classes.dotActive]: index === selectedIndex,
            })}
            selected={index === selectedIndex}
            onClick={() => scrollTo(index)}
            aria-label="dot"
          />
        ))}
      </div>
    </div>
  )
}

CarouselProductMobile.defaultProps = {
  items: [],
}

export default injectSheet(style)(memo(CarouselProductMobile))
